<a class="appname" routerLink="/" aria-label="Home Page">
  <app-logo [size]="38"></app-logo>
  <app-site-name></app-site-name>
</a>

<div class="categories">
  <a [routerLink]="['collection', newArrivalsNo]">New</a>
  <mat-divider></mat-divider>

  <a [routerLink]="['collection', bestSellersNo]">Best Sellers</a>
  @for (category of categories; track $index) {
  <mat-divider></mat-divider>

  <div class="category">
    <img
      ngSrc="{{category.icon | fileurl}}"
      width="64"
      height="64"
      alt="product category icon"
    />
    <ul>
      <li>
        <a routerLink="/search" [queryParams]="{category_ids: category.id}"
          >{{category.name}}</a
        >
      </li>
      @for (child of category.children; track $index) {
      <li>
        <a routerLink="/search" [queryParams]="{category_ids: child.id}"
          >{{child.name}}</a
        >
      </li>
      }
    </ul>
  </div>
  }
</div>
